import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { 
    initializeFirestore, 
    persistentLocalCache, 
    persistentMultipleTabManager 
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCk0nwaLfhooXZOArHVNq3Tbb2nfuKDcOA",
  authDomain: "quickbill-blr.firebaseapp.com",
  projectId: "quickbill-blr",
  storageBucket: "quickbill-blr.firebasestorage.app",
  messagingSenderId: "242612519612",
  appId: "1:242612519612:web:fc9be2ef305f788fba06b9"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

// Modern Offline Persistence with Multi-Tab Support
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const storage = getStorage(app);




